// Initialize.ts
import { startNetworkMonitoring } from './networkState';

// Start monitoring when the app initializes
const cleanup = startNetworkMonitoring();

// Optional: Clean up on app shutdown if needed
if (typeof window !== 'undefined') {
  window.addEventListener('unload', cleanup);
}
